import * as stylex from '@stylexjs/stylex';
import { FC } from 'react';
import { styles } from '../../styles';
import { Ticket } from '@pages/event/api/useFetchTicketSegment';
import { shouldShowTicketPresenceStatus } from '@features/event-participant-card/lib/should-show-ticket-presence-status';

interface TicketStatusSectionProps {
  ticket: Ticket;
  eventDateStart?: string;
  showPresence?: boolean;
}

export const TicketStatusSection: FC<TicketStatusSectionProps> = ({ ticket, eventDateStart, showPresence }) => {
  const showTicketPresenceStatus = showPresence ?? shouldShowTicketPresenceStatus(eventDateStart);

  return (
    <section {...stylex.props(styles.statusBlock)}>
      <div {...stylex.props(styles.statusBlockItem)}>
        <div {...stylex.props(styles.dataBlockTitle)}>Билет</div>
        <div {...stylex.props(styles.dataFields)}>
          <div {...stylex.props(styles.statusField)}>
            <span {...stylex.props(styles.dataFieldLabel)}>СМС:</span>
            <span {...stylex.props(styles.dataFieldValue)}>
              {ticket.smsTicketSent ? 'Отправлено' : 'Не отправлено'}
            </span>
          </div>
          <div {...stylex.props(styles.statusField)}>
            <span {...stylex.props(styles.dataFieldLabel)}>E-mail:</span>
            <span {...stylex.props(styles.dataFieldValue)}>
              {ticket.emailTicketSent ? 'Отправлено' : 'Не отправлено'}
            </span>
          </div>
        </div>
        {showTicketPresenceStatus && (
          <div {...stylex.props(styles.invitationStatusBlock, !ticket.checked && styles.invitationStatusBlockWarning)}>
            <span {...stylex.props(styles.invitationStatus)}>
              {ticket.checked ? 'Присутствовал' : 'Не присутствовал'}
            </span>
          </div>
        )}
      </div>
    </section>
  );
};
